import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectFromPricelistComponent } from './select-from-pricelist/select-from-pricelist.component';
import { SelectFromCardComponent } from './select-from-card/select-from-card.component';
import { PagesComponent } from '../pages.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PricelistCodeFilterPipe } from './pricelist-code-filter.pipe';
import { PricelistCodeRowComponent } from './pricelist-code-row/pricelist-code-row.component';
import { PricelistSeriesRowComponent } from './pricelist-series-row/pricelist-series-row.component';
import { TreatmentRowComponent } from './treatment-row/treatment-row.component';
import { TextEditorComponent } from 'src/app/shared/text-editor/text-editor.component';








export const routes: Routes = [
  {
    path: '', component: PagesComponent, children: [
      { path: '', redirectTo: 'select-from-card', pathMatch: 'full' },
      { path: 'select-from-card',         component: SelectFromCardComponent },
      { path: 'select-from-pricelist', component: SelectFromPricelistComponent },
      { path: 'text-editor', component: TextEditorComponent }
    ]
  }
];



@NgModule({
  declarations: [
    SelectFromPricelistComponent,
    SelectFromCardComponent,
    PricelistCodeFilterPipe,
    PricelistCodeRowComponent,
    PricelistSeriesRowComponent,
    TreatmentRowComponent

  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class TreatmentsModule { }
